/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PendingRetailerConfirmationItemDto
 */
export interface PendingRetailerConfirmationItemDto {
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationItemDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PendingRetailerConfirmationItemDto
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationItemDto
     */
    branchId: number | null;
    /**
     * 
     * @type {string}
     * @memberof PendingRetailerConfirmationItemDto
     */
    branchName: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingRetailerConfirmationItemDto
     */
    retailerPhone: string | null;
    /**
     * 
     * @type {string}
     * @memberof PendingRetailerConfirmationItemDto
     */
    currency: string | null;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationItemDto
     */
    originalSubtotal: number;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationItemDto
     */
    proposedSubtotal: number;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationItemDto
     */
    deliveryFee: number;
    /**
     * Distinct supplier names touching this order (cross-supplier indicator)
     * @type {Array<string>}
     * @memberof PendingRetailerConfirmationItemDto
     */
    suppliers: Array<string>;
    /**
     * Distinct reasons for retailer confirmation across items
     * @type {Array<string>}
     * @memberof PendingRetailerConfirmationItemDto
     */
    reasons: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PendingRetailerConfirmationItemDto
     */
    itemsAffected: number;
    /**
     * 
     * @type {Date}
     * @memberof PendingRetailerConfirmationItemDto
     */
    propagatedAt: Date | null;
}

/**
 * Check if a given object implements the PendingRetailerConfirmationItemDto interface.
 */
export function instanceOfPendingRetailerConfirmationItemDto(value: object): value is PendingRetailerConfirmationItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('orderNumber' in value) || value['orderNumber'] === undefined) return false;
    if (!('branchId' in value) || value['branchId'] === undefined) return false;
    if (!('branchName' in value) || value['branchName'] === undefined) return false;
    if (!('retailerPhone' in value) || value['retailerPhone'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('originalSubtotal' in value) || value['originalSubtotal'] === undefined) return false;
    if (!('proposedSubtotal' in value) || value['proposedSubtotal'] === undefined) return false;
    if (!('deliveryFee' in value) || value['deliveryFee'] === undefined) return false;
    if (!('suppliers' in value) || value['suppliers'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    if (!('itemsAffected' in value) || value['itemsAffected'] === undefined) return false;
    if (!('propagatedAt' in value) || value['propagatedAt'] === undefined) return false;
    return true;
}

export function PendingRetailerConfirmationItemDtoFromJSON(json: any): PendingRetailerConfirmationItemDto {
    return PendingRetailerConfirmationItemDtoFromJSONTyped(json, false);
}

export function PendingRetailerConfirmationItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingRetailerConfirmationItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'orderNumber': json['orderNumber'],
        'branchId': json['branchId'],
        'branchName': json['branchName'],
        'retailerPhone': json['retailerPhone'],
        'currency': json['currency'],
        'originalSubtotal': json['originalSubtotal'],
        'proposedSubtotal': json['proposedSubtotal'],
        'deliveryFee': json['deliveryFee'],
        'suppliers': json['suppliers'],
        'reasons': json['reasons'],
        'itemsAffected': json['itemsAffected'],
        'propagatedAt': (json['propagatedAt'] == null ? null : new Date(json['propagatedAt'])),
    };
}

export function PendingRetailerConfirmationItemDtoToJSON(value?: PendingRetailerConfirmationItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'orderNumber': value['orderNumber'],
        'branchId': value['branchId'],
        'branchName': value['branchName'],
        'retailerPhone': value['retailerPhone'],
        'currency': value['currency'],
        'originalSubtotal': value['originalSubtotal'],
        'proposedSubtotal': value['proposedSubtotal'],
        'deliveryFee': value['deliveryFee'],
        'suppliers': value['suppliers'],
        'reasons': value['reasons'],
        'itemsAffected': value['itemsAffected'],
        'propagatedAt': (value['propagatedAt'] == null ? null : (value['propagatedAt'] as any).toISOString()),
    };
}

